// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const AccordionContract = contract({
  name: "Accordion",
  description: "Long-form content that would overwhelm if shown all at once — FAQs, settings groups, \"what's included\" sections, nested help. For tab-style peer views with one always visible, reach for Tabs. For a single show/hide reveal use Collapsible.",
  import: "@gradeui/ui",
  aliases: ["accordion","faq","expand","collapse list","disclosure list","disclosure group","outline group","expandable list","sectionlist"],
  subcomponents: ["AccordionItem","AccordionTrigger","AccordionContent"],
  composesWith: ["Card (as a faq inside a card body)","Section primitives"],
  styleDefaults: {"AccordionItem":"border-b","AccordionTrigger":"flex flex-1 items-center justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180","AccordionContent":"pb-4 pt-0"},
  props: {
  "type": {
      schema: z.enum(["single", "multiple"]),
      design: "knob",
      description: "single keeps one open at a time, multiple lets several be open at once",
  },
  "collapsible": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "only valid with type=\"single\"; allows the open item to be toggled shut",
  },
  "defaultValue": {
      schema: z.union([z.string(), z.array(z.string())]).optional(),
      design: "knob",
      description: "initial open item(s)",
  },
  "value": {
      schema: z.union([z.string(), z.array(z.string())]).optional(),
      design: "knob",
      description: "controlled",
  },
  "onValueChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "children": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "the row label users click to expand",
  },
  },
});
